export const SLOT_LIST_REQUEST = 'SLOT/SLOT_LIST_REQUEST'
export const SLOT_LIST_SUCCESS = 'SLOT/SLOT_LIST_SUCCESS'
export const SLOT_LIST_FAIL = 'SLOT/SLOT_LIST_FAIL'

export const SLOT_SELECT_REQUEST = 'SLOT/SLOT_SELECT_REQUEST'
export const SLOT_SELECT_SUCCESS = 'SLOT/SLOT_SELECT_SUCCESS'
export const SLOT_SELECT_FAIL = 'SLOT/SLOT_SELECT_FAIL'